import React from 'react';
import {useFormSubmit} from '../../../controllers/useSubmitForm';
import {Form} from '../../../components/form/Form';

export const ImageForm = props => {
  const {
    route: {params},
    defaultValue,
    header = 'Add Image',
    mode,
  } = props;
  let {onSubmit} = useFormSubmit({
    uri: '/images',
    ...props,
  });
  const {department, product, row} = params;
  return (
    <Form
      api={`/images/${row?._id}`}
      fields={{
        task_list: {name: 1, is_completed: 1},
      }}
      onSubmit={onSubmit}
      header={header}
      submitAction={'Save'}
      defaultValues={{
        ...defaultValue,
        department: department?._id,
        product: product?._id,
        created_on: mode !== 'edit' ? new Date() : void 0,
        status: 'active',
      }}
      layoutFields={[
        {
          placeholder: 'Title',
          field: 'image_title',
          type: 'text',
        },
        {
          placeholder: 'Ad Creative',
          field: 'ad_creative_id',
          type: 'autoComplete',
          api: `/adcreatives`,
          suggestionField: 'ad_head_line',
          valueField: 'ad_head_line',
        },
        {
          field: 'reference',
          type: 'file',
          placeholder: 'Reference*',
          multiple: true,
        },
        {
          field: 'attachment',
          type: 'file',
          placeholder: 'Upload file*',
          multiple: true,
        },
      ]}
      {...props}
    />
  );
};

export const EditImageForm = props => {
  return <ImageForm mode="edit" header={'Edit Image Ad'} {...props} />;
};
